import t from "../../translations";

const blueQuotation = [
  t('blue_quotation'),
];

export default blueQuotation;
